import {SearchConditions} from '../types';
import {ChartPanel} from './ChartPanel';

interface ChartPanelListProps {
  mapList: string[];
  searchConditions: SearchConditions | null;
  xTimeliles: string[];
}

export const ChartPanelList = ({mapList, searchConditions, xTimeliles}: ChartPanelListProps) => {
  if (!searchConditions) return null;

  return (
    <>
      {mapList.map((map: string) => (
        <ChartPanel
          key={`ChartPanel-${map}`}
          searchConditions={searchConditions}
          selectedMap={map}
          xTimeliles={xTimeliles}
        />
      ))}
    </>
  );
};
